import { CustomizeBaseProductScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <CustomizeBaseProductScreen />;
}
